/* global Cookies */

import feefo from './includes/feefo';
import parallaxBg from './common/parallaxBg';
import smoothscroll from 'smoothscroll-polyfill';

export default {
    init() {

        this.sliderPromosEl = $('.slider-promos')
        this.sliderUspsEl = $('.slider-usps')
        this.searchEl = $('.main-header__search')
        this.searchInputEl = $('#header-search-input')
        this.offcanvasSubToggle = $('.nav--offcanvas .menu-item-has-children > a')
        this.track_order_form = $('.woocommerce-form-track-order')
        this.feature_Slider = $('.feature-slider')
        this.slickCarouselsEl = document.querySelectorAll('[data-slick-me]')
        parallaxBg.init() // Init wave parallax
        smoothscroll.polyfill()

        if (this.sliderPromosEl.length) {
            // NOTE: "invalid regular expression" error on mobile in chrome
            this.sliderPromos()
        }

        if (this.sliderUspsEl.length) {
            // NOTE: "invalid regular expression" error on mobile in chrome
            this.sliderUsps()
        }

        if (this.feature_Slider.length) {
            this.featureSliderControls()
        }
        
        if ($('.feefo-slider').length) {
            feefo.init()
        }

        if (this.slickCarouselsEl.length) {
            this.slickCarousels()
        }

        $('.scroll-to-top').click( () => {
            $('html,body').animate({
                scrollTop: $('html,body').offset().top,
            }, 1000)
        })

        $('[data-toggle="tooltip"]').tooltip()

        $('.offcanvas-toggle').click( (e) => {
            e.preventDefault()
            $('body').toggleClass('offcanvas-open')
            $('.offcanvas-overlay').fadeToggle()
        })

        $('.offcanvas-overlay').click( () => {
            $('body').removeClass('offcanvas-open')
            $('.offcanvas-overlay').fadeOut()
        })

        $('.main-header__search-toggle').click( (e) => {
            $(e.currentTarget).toggleClass('search-open')
            $('.main-header__search-input').fadeToggle()
        })

        $('.quick-basket-toggle').hover( (e) => {
            e.preventDefault()
            $('.quick-basket-wrap').addClass('quick-basket-open')
            $('.quick-account-wrap').removeClass('quick-account-open')
        })

        $('.quick-basket').mouseleave(function () {
            function hidequickbasket() {
                $('.quick-basket-wrap').removeClass('quick-basket-open')
            }

            setTimeout(hidequickbasket, 500)
        });

        $('.quick-account-toggle').click( (e) => {
            e.preventDefault()
            $('.quick-account-wrap').toggleClass('quick-account-open')
            $('.quick-basket-wrap').removeClass('quick-basket-open')
        })

        $('.checkout-login-accordion').click( (e) => {
            e.preventDefault()
            const self = e.currentTarget
            $(self).toggleClass('accordion-open')
            $('.checkout-login-form').slideToggle()
        })

        this.offcanvasSubToggle.click( (e) => {
            e.preventDefault()
            const self = $(e.currentTarget)
            const subMenu = self.parent('li').find('.sub-menu')

            this.offcanvasSubToggle.not(self).each( function() {
                $(this).removeClass('sub-menu-open')
                $(this).parent('li').find('.sub-menu').slideUp()
            })

            self.toggleClass('sub-menu-open')
            subMenu.slideToggle()

        })

        // OptinMonster pop-ups can load at any time, so don't rely on a DOM element being available before this JS can run.
        this.newsletterSignup()

        if (this.track_order_form.length) {
            this.trackOrderFormUpdateID()
        }

        $(window).on('resize orientationchange', function() {
            $('.global-banner-columns__carousel-wrap').slick('resize');
        });

    },
    sliderPromos() {

        this.sliderPromosEl.slick({
            dots: false,
            arrows: true,
            infinite: true,
            rows: 0,
            prevArrow: '<button type="button" class="slick-arrow slick-arrow--prev"><i class="far fa-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-arrow slick-arrow--next"><i class="far fa-angle-right"></i></button>',
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        })

    },
    sliderUsps() {

        this.sliderUspsEl.slick({
            dots: true,
            arrows: false,
            infinite: true,
            rows: 0,
            slidesToShow: 5,
            slidesToScroll: 5,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        })

    },
    newsletterSignup() {

        document.addEventListener('om.Optin.success', function(event) {

            // Check if email passed OptinMonster validation.
            if( event.detail.response.success == true ) {

                // Set cookie.
                Cookies.set('wp_optinmonster-optin', 'true', { expires: 365 });

            }

        });

    },
    trackOrderFormUpdateID() {

        $(document).on('submit', 'form.woocommerce-form-track-order', function() {
            var form = $(this)
            var order_id = form.find('input[name="orderid"]').val()

            // Create array of characters
            var prefixes = ['sp-', 'SP-', 'eb-', 'EB-', 'nu-', 'NU-', 'sb-', 'SB-', 'sa-', 'SA-', 'sg-', 'SG-'];

            // Loop through characters and remove from input.
            prefixes.forEach((item) => {
                if ( order_id.indexOf(item) !== -1 ) {
                    // Remove string from input
                    form.find('input[name="orderid"]').val(order_id.replace(item, ''));
                 }
            });

        });

    },
    slickCarousels() {

        /**
         * Intialize all slickCarousel(s) with defined settings. Some of the settings are added dynamically depending on the choice selected as part of the content block ACF settings.
         */

        // Grab all carousels and store
        var slickCarousels = document.querySelectorAll('[data-slick-me]');
        
        // Iterate through each
        $(slickCarousels).each(function() {
            // Initiate Carousels
            // @note Do not modify slick carousel settings via JS, please pass configuration from the template partial in JSON format via data-slick
            // Any settings provided here will override settings passed via this data attribute so do not add unless explicitly targetting all carousels
            $(this).slick();
        });

    },
    featureSliderControls() {

        $('.feature-slider__controls').on('init', function() {
            
            // Custom feature controls
            $('.feature-slider__controls .slick-slide').on('click', function () {
                const $parent = $(this).closest($('.feature-slider'))
                const $slides = $parent.find('.feature-slider__slides')
                const $currentControl = $parent.find('.feature-slider__controls .slick-slide.slick-current')
                $slides.slick('slickGoTo', $(this).data('slickIndex'));
                $currentControl.removeClass('slick-current')
                $(this).addClass('slick-current')
            });

        });

    },
};
